import { render, staticRenderFns } from "./TrainingVideosEditor.vue?vue&type=template&id=dc453602&scoped=true&"
import script from "./TrainingVideosEditor.vue?vue&type=script&lang=js&"
export * from "./TrainingVideosEditor.vue?vue&type=script&lang=js&"
import style0 from "./TrainingVideosEditor.vue?vue&type=style&index=0&id=dc453602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc453602",
  null
  
)

export default component.exports